import { formatMoney } from 'accounting'

import useStatus from '@hooks/useStatus'

import { SidebarModalListItem, StatusBadge } from '@domain-group/suit-theme'

import { OrderItemModel } from '@models/types'

const InvoiceCampaignOrderItem = (props: { orderItem: OrderItemModel }) => {
  const { orderItem } = props

  const {
    price_inc_fee, quantity, status_id, title,
  } = orderItem

  // @ts-expect-error TS2339
  const { color, status: { title: statusTitle } } = useStatus({ id: status_id })

  return (
    <SidebarModalListItem
      // @ts-expect-error TS2769
      secondaryText={formatMoney(price_inc_fee)}
      title={`${quantity} x ${title}`}
    >
      <StatusBadge
        color={color}
        ghost
        text={statusTitle}
      />
    </SidebarModalListItem>
  )
}

export default InvoiceCampaignOrderItem
